<template>
  <div :key="componentKey">
    <!-- <form @submit.prevent="searchForm" @input.prevent="searchTimeOut">
      <v-btn color="primary" icon dark @click="openItem = true">
        <v-icon>mdi-plus</v-icon></v-btn
      >
      <v-text-field
        class="pb-5"
        v-model="search"
        chips
        clearable
        hide-details
        hide-selected
        prepend-icon="mdi-magnify"
        label="Search"
        solo
        @click:prepend="searchForm"
        @click:append="searchForm"
      />
    </form> -->

    <div v-on:mousemove="updateMouseCoordinates">
      <v-data-table
        :headers="headersComp"
        :items="items"
        :items-per-page="pagination.limit"
        class="elevation-1"
        disable-sort
        hide-default-footer
        @click:row="rowClick"
      >
      </v-data-table>

    </div>
    <div class="text-center">
      <!-- <v-pagination
        @input="changePage"
        v-model="pagination.page"
        :length="pagination.pages"
      ></v-pagination> -->

      <v-menu
        v-model="rowMenu.showMenu"
        :position-x="rowMenu.menuX"
        :position-y="rowMenu.menuY"
      >
        <v-list dense rounded>
          <v-list-item
            v-for="(action, index) in actions"
            :key="index"
            link
            @click="action.handle()"
          >
            <v-list-item-icon>
              <v-icon :color="action.color">{{ action.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ action.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-divider v-if="schemaActions && schemaActions.length"></v-divider> -->

        </v-list>
      </v-menu>
    </div>
    
      <CreateItensNotaFiscalView 
          :open="openItem"
          :itemEdit="itemSelected"
          :itemsByRomaneio="itemsByRomaneio"
          :jobSelected="jobSelected"
          :isNfRemessa="isNfRemessa"
          :isNfReferenciada="isNfReferenciada"
          @save="handleSaveItem"
          @cancel="openItem = false"
      />

  </div>
</template>

<script>
import Vue from 'vue'
import schemaService from "../../../services/schemaService";
import EntityService from "../../../services/entityService";

export default {
    name: 'TableNotaFiscal',
    //mixins: [entityPageMixin],
    props: ["schemaName", "ids", "relation", "item", 'itemsByRomaneio', 'jobSelected', 'isNfRemessa', 'isNfReferenciada'],
    components: {
        CreateItensNotaFiscalView: () => import('./CreateItensNotaFiscalView.vue')
    },
    data() {
        return {
            entityService: new EntityService('FisPreDocEmiItem'),
            openItem: false,
            schema: null,
            itemSelected: {},
            ncmFromJob: '',
            rowMenu: {
              showMenu: false,
              closeOnContentClick: false,
              x: 0,
              y: 0,
              menuX: 0,
              menuY: 0,
            },
            rowMenuOpen: false,
            pagination: {
              page: 1,
              limit: 30,
              pages: 1,
            },
            notVisibleTable: ['itemDescription', 'ordemDeServicoDescricao'],
            items: [],
            componentKey: 0,
            actions: [
                {
                    title: 'Visualizar/Editar',
                    icon: "mdi-pencil",
                    color: "warning",
                    handle: () => {
                      this.openItem = true;
                    }
                },
                {
                    title: 'Deletar',
                    icon: 'mdi-delete',
                    color: 'red',
                    handle: (type) => this.$emit('delete', type)
                }
            ],
        }
    },

    computed: {
      headersComp() {
        if (!this.schema) return [];

        let form = this.schema?.form?.properties;

        let properties = this.schema?.properties;
        let propertiesNames = Object.getOwnPropertyNames(properties || []);

        let maps = propertiesNames
          .filter((pn) => (properties[pn].relationSchema == null && !this.notVisibleTable.includes(pn)
          ) && form[pn])
          .map((p) => {
            let prop = form[p];
            return { text: prop.label, value: p, width: p == 'descricao' ? 500 : 100 };
          });

        if (this.schema.propertiesVisibleTable) {
          let propertiesVisibleTable = this.schema.propertiesVisibleTable?.split(',')
          maps.sort((a, b) => {

            let valueA = propertiesVisibleTable.indexOf(a.value);
            let valueB = propertiesVisibleTable.indexOf(b.value);

            if (valueA > valueB) return 1;
            else if (valueA < valueB) return -1;
            else return 0;


          });
        } else {
          maps.splice(maps.length - 1);
        }
        return maps;
      },
    },

    methods: {

      timeout(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
      updateMouseCoordinates(event) {
        this.rowMenu.x = event.clientX;
        this.rowMenu.y = event.clientY;
      },

      async openRowMenu() {
        await this.timeout(100);
        this.rowMenu.menuX = this.rowMenu.x;
        this.rowMenu.menuY = this.rowMenu.y;

        this.$nextTick(() => {
          this.rowMenu.showMenu = true;
        });
      },

      async rowClick(row) {
        this.itemSelected = Object.assign({}, row);
        await this.openRowMenu();
      },
      
      async getSchema() {
        let res = await schemaService.getByName(this.schemaName);
        if (res?.data?.success) {
          this.schema = JSON.parse(res.data.data.jsonValue);
        }
      },
      async searchForm(){
          //this.searchItems()
      },

      parseMoeda(valor) {
          if (!valor) return 0;

          return parseFloat(
              valor.toLocaleString()
              ?.replace(/[^\d,.-]/g, '')
              ?.replace(/\./g, '')
              ?.replace(',', '.')
          ) || valor;
      },

      handleSaveItem(item){

        const itemUpdate = this.items.findIndex((i) => i.sequencia == item.sequencia)
        this.items[itemUpdate] = item
        this.openItem = false;  
        this.componentKey += 1
        
        this.$emit('save-item', this.items)

      },

      getUniqueLatest(data) {
        const map = new Map();

        data.forEach(entry => {
          // pega a data mais relevante (se houver updateAt usa ele, senão createAt)
          const dateAtual = entry.updateAt ? new Date(entry.updateAt) : new Date(entry.createAt);

          if (!map.has(entry.item)) {
            map.set(entry.item, entry);
          } else {
            const existente = map.get(entry.item);
            const dateExistente = existente.updateAt ? new Date(existente.updateAt) : new Date(existente.createAt);

            // substitui pelo mais recente
            if (dateAtual > dateExistente) {
              map.set(entry.item, entry);
            }
          }
        });

        return Array.from(map.values());
      }

    },

    watch: {
      items(test){
        //console.log('TESTE AQUI ', test)
      },
      async itemsByRomaneio(value){
        console.log('itemsByRomaneio ', value)
        this.items = []

        if(this.jobSelected.ncm){
            await Vue.prototype.$http.get(`/Entity/NCM/${this.jobSelected.ncm}`).then((response) => {
                this.ncmFromJob = response.data.data.codigo;
            }).catch((error) => {
                console.error("Error fetching NCM:", error);
            });

            console.log('NCM from Job:', this.ncmFromJob);
        }

        for (let index = 0; index < value.length; index++) {

          const item = value[index]

          console.log('item >>> ', item.pisValor)

          if(item.id != undefined){
            this.items.push({ 
              ...item,
              pisPercentual: item.pisPercentual?.replace(',', '.'),
              valorUnitario: Number(item?.valorUnitario / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              valorTotal: Number(item?.valorTotal / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              icmsValor: Number(item.icmsValor / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              pisValor: Number(item.pisValor / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              cofinsValor: Number(item.cofinsValor / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              ipiValor: Number(item.ipiValor).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              valorFrete: (item.valorFrete / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              valorSeguro: (item.valorSeguro / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              valorOutros: (item.valorOutros / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0,
              valorDesconto: (item.valorDesconto / 100).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || 0
            })
            continue
          }


          let itemUniqueLatestByItem
          if(this.isNfRemessa){
            const response = await Vue.prototype.$http.get('/Entity/StockBalance/search-fields', {
              params: {
                searchFields: 'itemDescricao',
                value: item.descricao,
                sortField: 'createAt'
              }
            })

            const itensResponse = response.data.data.data
            const itemsUniqueLatest = this.getUniqueLatest(itensResponse)

            itemUniqueLatestByItem = itemsUniqueLatest.find((i) => i.itemDescricao == value[index].descricao)
          }

          //console.log('valorJob >>> ', this.jobSelected.valorJob)

          let valorJob = Number(this.jobSelected.valorJob).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || 0

          this.items.push({
                pedidodecompra: '',
                item: undefined,
                itemDescription: undefined,
                codigo: item?.codigo || undefined,
                ordemDeServico: !this.isNfRemessa ? item?._id || undefined : undefined,
                ordemDeServicoDescricao: !this.isNfRemessa ? item?.descricao || undefined : undefined,
                itemPav: this.isNfRemessa ? item.itemCaldeiraria : undefined,
                descricao: item?.descricao || undefined,
                operacaoFiscal: '',
                sequencia: index + 1,
                sequenciaPedidoDeCompra: '',
                pedidodevenda: '',
                itensPedidoDeVenda: '',
                ipiPercentualBaseCalculo: '',
                ipiBaseCalculo: 0,
                ipiPercentual: 0,
                ipiValor: 0,
                ipiAplicaSobreICMS: false,
                icmsPercentualBaseCalculo: '',
                icmsBaseCalculo: !this.isNfRemessa && !this.isNfReferenciada ? valorJob : '',
                icmsPercentual: 0,
                icmsValor: 0,
                ctsPis: '00 - Tributada integralmente',
                ctsIpi: '00 - Tributada integralmente',
                ctsIcms: '00 - Tributada integralmente',
                ctsCofins: '00 - Tributada integralmente',
                quantidade: '1,000',
                pisPercentualBaseCalculo: '',
                pisBaseCalculo: 0,
                pisPercentual: !this.isNfRemessa && !this.isNfReferenciada ? '1.65' : '',
                valorUnitario: this.isNfRemessa ? Number(itemUniqueLatestByItem?.valorReal).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || 0 : valorJob,
                valorTotal: this.isNfRemessa ? Number(itemUniqueLatestByItem?.valorReal).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || 0 : valorJob,
                pisValor: 0,
                cofinsPercentualBaseCalculo: '',
                cofinsBaseCalculo:  0,
                cofinsPercentual: !this.isNfRemessa && !this.isNfReferenciada ? '7,60' : null,
                cofinsValor: 0,
                ncm: this.ncmFromJob || '',
                observacao: '',
                pesoBruto: '',
                pesoLiquido: '',
                cest: '',
                unidadeSigla: item?.unidadeSigla || ''
            })
        //})
        }

        let itemsCopy = []
        
        this.items?.forEach((item) => {
          if(itemsCopy.filter((copy) => copy.id === item.id).length == 0){
            itemsCopy.push({
              ...item,
            })
          }
        })

        console.log('itemsCopy >>> ', itemsCopy)

        this.$emit('save-item', itemsCopy)
      }
    },

    async mounted(){
      await this.getSchema()
    }
}
</script>